<template>
    <div class="panel global-score rounded">
        <div class="row dashboard-header">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="row">
                  <div class="col-md-6">
                    <h3 v-if="parsedProps.account">
                      {{parsedProps.account.name}}
                    </h3>
                    <h3 v-if="downloadconsumerdutyreport ?? false">The Consumer Duty Board Report</h3>
                    <h3 v-else>Action tracker</h3>
                  </div>

                  <div class="col-md-6">
                    <div class="col-md-12 col-sm-12 col-xs-12" v-if="!isprint && (!parsedProps.isNetwork || (parsedProps.isNetwork && networkcanprint)) && parsedProps.account">
                      <i class="fa fa-print pull-right" id="printActionTracker" @click="printPage"></i>
                    </div>
                    <br>
                    <div class="col-md-12 col-sm-12 col-xs-12" v-if="consumerdutyurl">
                      <a :href="consumerdutyurl" class="dashboard-action-t-active pull-right">The Consumer Duty Board Report </a>
                    </div>
                    <div v-if="trackerai ?? false" class="col-md-12 col-sm-12 col-xs-12">
<!--                      <a href="/assessment/action-tracker-ai-index" type="button" class="btn ai-generated-btn pull-right">-->
<!--                        <i class="fa fa-magic" aria-hidden="true"></i>-->
<!--                        AI Generated Data Analytics-->
<!--                      </a>-->
                      <button
                          type="button"
                          class="btn ai-generated-btn pull-right"
                          @click="showAiAnalytics = !showAiAnalytics"
                          v-if="!isprint"
                      >
                        <i class="fa fa-magic" aria-hidden="true"></i>
                        {{ showAiAnalytics ? 'Hide AI Data Analytics' : 'AI Generated Data Analytics' }}
                      </button>
                    </div>
                    <div class="col-md-12 col-sm-12 col-xs-12" v-if="downloadconsumerdutyreport">

                      <div class="pull-right">

                        <img class="img-responsive" src="/img/consumer-duty-board-report.png" style="width: 50px; margin-top: 5px; margin-bottom: 5px">

                        <div class="btn-group">

                          <button type="button" class="btn btn-report" @click="handleReportClick" :disabled="selectedReportFormat === 'docx' && reportState.status === 'processing'">

                            <span v-if="selectedReportFormat === 'pdf'">Download PDF</span>

                            <span v-else-if="reportState.status === 'idle'">Generate DOCX</span>

                            <span v-else-if="reportState.status === 'processing'"><i class="fa fa-spinner fa-spin"></i> Generating...</span>

                            <span v-else-if="reportState.status === 'error'">Retry DOCX</span>

                            <span v-else>Download DOCX</span>

  <!--                          <i v-if="selectedReportFormat === 'pdf' || reportState.status === 'ready'" class="fa fa-download"></i>-->
                          </button>

                          <button type="button" class="btn btn-report dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="caret"></span>
                            <span class="sr-only">Toggle Dropdown</span>
                          </button>

                          <ul class="dropdown-menu dropdown-menu-right">
                            <li>
                              <a href="#" @click.prevent="selectedReportFormat = 'pdf'">
                                <i class="fa fa-file-pdf-o"></i> PDF
                              </a>
                            </li>
                            <li>
                              <a href="#" @click.prevent="selectedReportFormat = 'docx'">
                                <i class="fa fa-file-word-o"></i> DOCX
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div v-if="parsedProps.isNetworkSbg" class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="grouping-select">View Mode:</label>
              <select id="grouping-select" class="form-control"
                      v-model="groupBySeverity"
                      @change="onGroupByChange">
                <option :value="true">Grouped by Severity</option>
                <option :value="false">Show by Auditor Index</option>
              </select>
            </div>
          </div>
        </div>
        <ActionTrackerFilterComponent
            :filters="filtersData"
            @onSelect="handleSelectedFilterChange"
            v-if="!isprint"
        />
        <action-tracker-ai
            v-if="showAiAnalytics && !isprint"
            :severity-groups="aiSeverityGroups"
            :selected-filters="selectedFilters"
            :group-by-severity="groupBySeverity"
            :enabledparentcategories="enabledparentcategories"
            :initial-metric-dashboard="aiMetricDashboard"
            :returned-from-action="aiFrom"
            @open-action="openActionFromAi"
            @dismiss-returned-action="dismissReturnedAction"
            @drill-change="onAiDrillChange"
            @metric-dashboard-change="onAiMetricDashboardChange"
            @close="showAiAnalytics = false"
        />
        <ActionTrackerTableComponent
            :groupBySeverity="groupBySeverity"
            :severityGroups="severityGroups"
            :severityLabels="parsedProps.severityLabels"
            :selectedFilters="selectedFilters"
            :sortDir="sortDir"
            :sortColumn="sortColumn"
            :showCompleted="showCompleted"
            :completedCount="completedCount"
            :isTrial="istrial"
            :showNaAnswers="shownaanswers"
            @onSort="sortSeverityGroupBy"
            @onEditAnswer="editAnswer"
            @onShowCompletedAnswers="showCompletedAnswers"
        />
    </div>
</template>

<script>
    export default {
        props: [
          'account',
          'answers',
          'filters',
          'isnetwork',
          'isnetworksbg',
          'severitylabels',
          'isprint',
          'networkcanprint',
          'shownaanswers',
          'istrial',
          'consumerdutyurl',
          'downloadconsumerdutyreport',
          'downloadconsumerdutyreportpdfurl',
          'downloadconsumerdutyreportdocurl',
          'trackerai',
          'enabledparentcategories',
        ],
        data() {
            return {
                parsedProps: {},
                filtersData: [],
                selectedFilters: [],
                sortDir: 'desc',
                sortColumn: 'status',
                severityGroups: [],
                showCompleted: {},
                completedCount: {},
                hiddenCompletedAnswers: [],
                currentSortActiveDirection: 'active fa-sort-desc',
                queryUrlParams: '',
                groupBySeverity: true,
                showAiAnalytics: false,
                aiMetricDashboard: null,
                aiFrom: null,
                selectedReportFormat: 'pdf',
                reportState: {
                  status: 'idle',  // idle | processing | ready | error
                  url: null
                }
            }
        },
        mounted() {
            // Coming back from an action page via Back may restore this page
            // from the browser's back/forward cache with stale answers.
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) {
                    window.location.reload();
                }
            });

            let urlParams = this.getHistoryUrlParams(window.location.href);
            try{
                    const filters = JSON.parse(this.filters);
                    this.filtersData = Object.keys(filters).map(key => {
                        return {
                            name: key,
                            default: filters[key].defaults,
                            selected: urlParams[key] || null,
                            // options: filters[key].data.map((text, value) => ({ text, value, visible: true })),
                            options: [
                                { text: 'Reset', value: null, visible: true },
                                ...filters[key].data.map((text, value) => ({ text, value, visible: true })),
                            ],
                        }
                    });

                    this.parsedProps = {
                        account: JSON.parse(this.account),
                        answers: JSON.parse(this.answers),
                        filters: filters,
                        isNetwork: this.isnetwork ? true : false,
                        isNetworkSbg: this.isnetworksbg ? true : false,
                        severityLabels: this.severitylabels ? JSON.parse(this.severitylabels) : null,
                    }

                if (urlParams) {
                    this.selectedFilters = Object.keys(urlParams)
                        .filter(key => filters[key] && filters[key].data[urlParams[key]])
                        .reduce((acc, key) => {
                            acc[key] = {
                                name: filters[key].data[urlParams[key]],
                                value: +urlParams[key],
                            };
                            return acc;
                        }, {});

                    if (urlParams['sortColumn'] && urlParams['sortDir']) {
                        this.sortColumn = urlParams['sortColumn'];
                        this.sortDir = urlParams['sortDir'];
                    }

                    if (urlParams['groupBySeverity'] !== undefined) {
                        this.groupBySeverity = urlParams['groupBySeverity'] !== '0';
                    } else {
                        this.groupBySeverity = true;
                    }

                    this.showAiAnalytics = urlParams['ai'] === '1';
                    this.aiMetricDashboard = urlParams['aiDashboard'] || null;
                    this.aiFrom = urlParams['aiFrom'] || null;

                    if(urlParams['scrollY']){
                        this.$nextTick(() => {
                            window.scroll({top: urlParams['scrollY'], behavior: 'smooth'});
                        });
                    }
                }
                // set initial data
                this.severityGroups = this.initialData();
                this.scroll();
            }catch(e){
                console.log(e);
            }
        },
        created() {
            this.$root.ActionTracker = this;
        },
        watch: {
            showAiAnalytics() {
                this.setHistoryUrlParams();
            }
        },
        computed: {
            // The table collapses Completed actions behind a "show completed"
            // link, but AI analytics must count them, so add them back here.
            aiSeverityGroups() {
                if (!this.hiddenCompletedAnswers.length) {
                    return this.severityGroups;
                }

                const groups = this.severityGroups.map(group => ({
                    ...group,
                    answers: [...(group.answers || [])]
                }));

                this.hiddenCompletedAnswers.forEach(answer => {
                    let group = groups.find(item => item.severity === answer.severity);

                    if (!group) {
                        group = {
                            severity: answer.severity,
                            title: this.severityTitle(answer.severity),
                            color: this.severityColor(answer.severity),
                            answers: []
                        };
                        groups.push(group);
                    }

                    group.answers.push(answer);
                });

                return groups.sort((a, b) => a.severity - b.severity);
            }
        },
        methods: {
            handleSelectedFilterChange(option, index){
                let filtersDataNew = [...this.filtersData];
                filtersDataNew[index].selected = option.value;

                if (filtersDataNew[index].name === 'parent') {
                    this.clearSectionOutsideParent(filtersDataNew, option);
                }

                this.filtersData = filtersDataNew;


                this.selectedFilters = this.buildSelectedFilters(filtersDataNew);

                this.severityGroups = this.initialData();
            },

            // A Business Function that doesn't belong to the newly selected
            // Regulatory Key would leave the table and AI dashboard empty.
            clearSectionOutsideParent(filtersData, parentOption) {
                const section = filtersData.find(filter => filter.name === 'section');

                if (!section || section.selected === null || section.selected === undefined || !parentOption.value) {
                    return;
                }

                const sectionOption = section.options.find(item => item.value == section.selected);

                const belongs = sectionOption && this.parsedProps.answers.some(answer => {
                    return answer.parent == parentOption.text && answer.section == sectionOption.text;
                });

                if (!belongs) {
                    section.selected = null;
                }
            },

            buildSelectedFilters(filtersData) {
                return filtersData.reduce((acc, filter) => {
                    if (filter.selected !== null && filter.selected !== undefined) {
                        acc[filter.name] = {
                            name: filter.options.find(option => option.value == filter.selected).text,
                            value: filter.selected,
                        };
                    }
                    return acc;
                } , {});
            },

            // AI Data Analytics drill-through -> Regulatory Key / Business
            // Function filters, so the table and the dashboard share one scope.
            onAiDrillChange({ parent, section }) {
                const wanted = { parent, section };

                const filtersDataNew = this.filtersData.map(filter => {
                    if (!Object.prototype.hasOwnProperty.call(wanted, filter.name)) {
                        return filter;
                    }

                    const text = wanted[filter.name] ? String(wanted[filter.name]).trim().toLowerCase() : null;
                    const option = text
                        ? filter.options.find(item => item.value !== null && String(item.text).trim().toLowerCase() === text)
                        : null;

                    return { ...filter, selected: option ? option.value : null };
                });

                this.filtersData = filtersDataNew;
                this.selectedFilters = this.buildSelectedFilters(filtersDataNew);
                this.severityGroups = this.initialData();
            },

            // AI Data Analytics panel state, kept in the URL so reloading or
            // coming back from an action reopens the same dashboard.
            aiUrlParams() {
                if (!this.showAiAnalytics) {
                    return '';
                }

                return '&ai=1' + (this.aiMetricDashboard ? '&aiDashboard=' + encodeURIComponent(this.aiMetricDashboard) : '');
            },

            // Remember where the user was (filters, AI dashboard, scroll and the
            // action itself) so the action page's Back returns to the same
            // dashboard and shows whether the action is now done.
            openActionFromAi(questionId) {
                this.setHistoryUrlParams();

                const params = this.getHistoryUrlParams(window.location.href);
                params.scrollY = Math.round(window.scrollY);
                params.aiFrom = questionId;

                history.replaceState({name: 'action-tracker'}, 'action-tracker', '?' + new URLSearchParams(params).toString());

                this.editAnswer(questionId);
            },

            dismissReturnedAction() {
                this.aiFrom = null;

                const params = this.getHistoryUrlParams(window.location.href);
                delete params.aiFrom;

                history.replaceState({name: 'action-tracker'}, 'action-tracker', '?' + new URLSearchParams(params).toString());
            },

            onAiMetricDashboardChange(type) {
                this.aiMetricDashboard = type;
                this.setHistoryUrlParams();
            },

            reduceFilters(answers) {
                this.filtersData = this.filtersData.map(item => {
                    switch(item.name){
                        case 'section':
                            return {
                            ...item,
                            options: item.options.map(option => ({
                                ...option, 
                                visible: !this.selectedFilters.parent || 
                                        option.text == 'Reset' ||
                                        option.text == 'All' ||
                                        this.parsedProps.answers.filter(answer =>
                                            answer.section == option.text && 
                                            answer.parent == this.selectedFilters.parent.name
                                        ).length > 0
                            })),
                        }
                        case 'parent':
                            return {
                            ...item,
                            options: item.options.map(option => ({
                                ...option, 
                                visible: !this.selectedFilters.section || 
                                        option.text == 'Reset' ||
                                        option.text == 'All' ||
                                        this.parsedProps.answers.filter(answer =>
                                            answer.parent == option.text && 
                                            answer.section == this.selectedFilters.section.name
                                        ).length > 0
                            })),
                        }
                        case 'answer':
                            let answersOptions = answers.reduce((acc, answer) => {
                                if (!acc.has(answer.answer)) {
                                    acc.add(answer.answer);
                                }
                                return acc;
                            }, new Set([]));

                            return {
                            ...item,
                            options: item.options.map(option => ({
                                ...option, 
                                visible: option.text == 'Reset' || option.text == 'All' ||
                                        answersOptions.has(option.text)
                            })),
                        }
                        case 'severity':
                        case 'archived':
                        case 'documents':
                        case 'notes':
                        case 'name': {
                            // Records left by every other selected filter, so the filter keeps its own
                            // alternatives (e.g. "Without documents" while "With documents" is selected).
                            const otherFilters = Object.assign({}, this.selectedFilters);
                            delete otherFilters[item.name];

                            let base = this.filterBy(this.parsedProps.answers, otherFilters);

                            if (item.name !== 'archived') {
                                base = base.filter(answer => !this.isArchivedHidden(answer));
                            }

                            return {
                            ...item,
                            options: item.options.map(option => ({
                                ...option,
                                visible: option.text == 'Reset' || option.text == 'All' ||
                                        this.filterBy(base, { [item.name]: { name: option.text, value: option.value } }).length > 0
                            })),
                        }
                        }
                        default:
                            return item;
                    }    
                });
            },

            isArchivedHidden: function (answer) {
                return (!this.selectedFilters['archived'] || this.selectedFilters['archived'].value === 1)
                    && answer.archived !== null && answer.archived !== 0;
            },

            showCompletedAnswers: function (group) {
                this.showCompleted[group.severity] = true;
                this.severityGroups = this.initialData();
            },
            
            scroll: function () {
                self = this;
                window.addEventListener('scroll', function (e) {
                    // let scrollPos = window.scrollY;
                    // let winHeight = window.innerHeight;
                    // let docHeight = document.documentElement.scrollHeight;
                    self.changeScrollHistoryUrlParams(window.scrollY);
                });
            },
            // get url params, and return array as key=>value
            getHistoryUrlParams: function (url) {
                let params = {};
                (url + '?').split('?')[1].split('&').forEach(function (pair) {
                    pair = (pair + '=').split('=').map(decodeURIComponent);
                    if (pair[0].length) {
                        params[pair[0]] = pair[1];
                    }
                });
                return params;
            },
            // set history url with sort & filter params
            setHistoryUrlParams: function () {
                let sort = '', scroll = '', filter = '', urlParams = '';
                sort = sort.concat('?sortColumn=', this.sortColumn + '&sortDir=', this.sortDir);

                if (!this.groupBySeverity) {
                  filter = filter.concat('&groupBySeverity=0');
                }

                if (this.selectedFilters) {
                    Object.keys(this.selectedFilters).forEach((key) => {
                        if (this.selectedFilters[key] && this.selectedFilters[key].value != null && key !== 'sortColumn' && key !== 'sortDir' && key !== 'scrollY') {
                            filter = filter.concat('&', key, '=', this.selectedFilters[key].value);
                        }
                    });
                }
                filter = filter.concat(this.aiUrlParams());
                scroll = scroll.concat('&scrollY=', 0);
                urlParams = urlParams.concat(sort, scroll, filter);
                if (window.location.search !== urlParams) {
                    history.pushState({name: 'action-tracker'}, 'action-tracker', urlParams);
                }
                this.queryUrlParams = urlParams;
            },
            changeScrollHistoryUrlParams: function (scrollY) {
                let sort = '', scroll = '', filter = '', params = '', urlParams = '';
                urlParams = this.getHistoryUrlParams(window.location.href);
                sort = sort.concat('?sortColumn=', urlParams['sortColumn'] + '&sortDir=', urlParams['sortDir']);

                Object.keys(urlParams).forEach((key) => {
                  if (urlParams[key] && urlParams[key] != null && key !== 'sortColumn' && key !== 'sortDir' && key !== 'scrollY') {
                    filter = filter.concat('&', key, '=', urlParams[key]);
                  }
                });

                if (!this.groupBySeverity) {
                  filter = filter.concat('&groupBySeverity=0');
                }

              scroll = scroll.concat('&scrollY=', scrollY);
                params = params.concat(sort, scroll, filter);
                history.pushState({name: 'action-tracker'}, 'action-tracker', params);
                this.queryUrlParams = params;
            },
            editAnswer: function (id) {
              let fromConsumerDutyDashboard = this.downloadconsumerdutyreport ? '/1' : '';
                if(this.parsedProps.isNetwork)
                    window.location.href = `/member-firm/results/action-tracker/${JSON.parse(this.account).id}/${id}${fromConsumerDutyDashboard}`;
                else
                    window.location.href = `/assessment/action-tracker/${id}${fromConsumerDutyDashboard}`;
            },
            // initialData: function () {
            //     let answers = this.answersColor(this.filterBy(this.parsedProps.answers));
            //     let groups = {};
            //     let completedCount = [];
            //     if(answers){
            //         answers.forEach(answer => {
            //             if(
            //                 (answers.length > 1) &&
            //                 (!this.selectedFilters['status'] || (this.selectedFilters['status'].value != 4 && this.selectedFilters['status'].value != 0)) &&
            //                 (answer.status == 'Completed' && !this.showCompleted[answer.severity])
            //             ) {
            //
            //                 if(!completedCount[answer.severity])
            //                     completedCount[answer.severity] = 0;
            //
            //                 completedCount[answer.severity] += 1;
            //                 return;
            //             }
            //
            //             if(!groups[answer.severity]){
            //                 groups[answer.severity] = {
            //                     severity: answer.severity,
            //                     title: this.severityTitle(answer.severity),
            //                     color: this.severityColor(answer.severity),
            //                     answers: [answer]
            //                 }
            //             }else{
            //                 groups[answer.severity].answers.push(answer)
            //             }
            //         });
            //         this.completedCount = completedCount;
            //     }
            //     this.reduceFilters(answers);
            //     return Object.values(groups).map(group => {
            //         group.completedLinkTitle = this.completedLinkTitle(group.severity, this.completedCount[group.severity] || 0);
            //         group.answers = this.sortBy(group.answers, null, false);
            //         return group;
            //     }).sort((a,b) => a.severity - b.severity);
            // },
          initialData: function (sort_column = null, sort_dir = false) {
            // let answers = this.answersColor(this.filterBy(this.parsedProps.answers));

            let filteredAnswers = this.filterBy(this.parsedProps.answers);

            // Important: keep N/A available in the Answer filter
            this.reduceFilters(filteredAnswers);

            // Hide N/A from the normal Action Tracker view,
            // but show it when N/A is selected in the Answer filter
            let answers = this.answersColor(this.hideNaAnswersUnlessFiltered(filteredAnswers));

            this.hiddenCompletedAnswers = [];

            if (!this.groupBySeverity) {
              answers = this.sortBy(answers, sort_column, sort_dir);

              answers = answers.filter(answer => {
                if (!this.selectedFilters['archived'] || this.selectedFilters['archived'].value === 1) {
                  return !answer.archived || answer.archived === 0;
                }
                return true;
              });

              return [{
                severity: null,
                title: 'All Questions',
                color: 'blue',
                answers: answers,
              }];
            }

            let groups = {};
            let completedCount = [];
            let hiddenCompletedAnswers = [];
            if (answers) {
              answers.forEach(answer => {
                if (
                    (answers.length > 1) &&
                    (!this.selectedFilters['status'] || (this.selectedFilters['status'].value != 4 && this.selectedFilters['status'].value != 0 && this.selectedFilters['status'].value != 5)) &&
                    (answer.status == 'Completed' && !this.showCompleted[answer.severity])
                ) {
                  if (!completedCount[answer.severity])
                    completedCount[answer.severity] = 0;

                  completedCount[answer.severity] += 1;

                  if (!this.isArchivedHidden(answer)) {
                    hiddenCompletedAnswers.push(answer);
                  }
                  return;
                }

                if (!this.selectedFilters['archived'] || this.selectedFilters['archived'].value === 1) {
                  if (answer.archived !== null && answer.archived !== 0) {
                    return;
                  }
                }

                if (!groups[answer.severity]) {
                  groups[answer.severity] = {
                    severity: answer.severity,
                    title: this.severityTitle(answer.severity),
                    color: this.severityColor(answer.severity),
                    answers: [answer]
                  }
                } else {
                  groups[answer.severity].answers.push(answer)
                }

              });
              this.completedCount = completedCount;
              this.hiddenCompletedAnswers = hiddenCompletedAnswers;
            }

            // this.reduceFilters(answers);
            return Object.values(groups).map(group => {
              group.completedLinkTitle = this.completedLinkTitle(group.severity, this.completedCount[group.severity] || 0);
              group.answers = this.sortBy(group.answers, null, false);
              return group;
            }).sort((a, b) => a.severity - b.severity);
          },

          getStatusOrder: function (status) {
                if (!status) return 0;
                if (status == 'On Track') return 1;
                if (status == 'Delayed') return 2;
                if (status == 'Severely Delayed') return 3;
                if (status == 'Completed') return 4;
            },
            filterBy: function (answers, filters=null) {
                var answersFiltered = answers;
                const activeFilters = filters || this.selectedFilters;

                if(!this.checkCorrectlyAnsweredStatus()){
                    answersFiltered = answersFiltered.filter((answer) => {
                        return !answer.initially_correct;
                    });
                }
                
                Object.keys(activeFilters).forEach((key) => {
                    if(activeFilters[key] ){
                        if (key == 'status' && activeFilters[key].value == 5) {
                            // Any positive answer: given in the assessment or
                            // fixed later in the Action Tracker.
                            answersFiltered = answersFiltered.filter((answer) => {
                                return answer.correctly_answered === true || Number(answer.correctly_answered) === 1;
                            });
                        } else if (key == 'status' && activeFilters[key].value == 4) {
                            answersFiltered = answersFiltered.filter((answer) => {
                                return answer['status'] == "Completed"
                            });
                        }  else if (key == 'status' && activeFilters[key].value == 3) {
                            answersFiltered = answersFiltered.filter((answer) => {
                                return answer['status'] == "Severely Delayed"
                            });
                        } else if (key == 'status' && activeFilters[key].value == 2) {
                            answersFiltered = answersFiltered.filter((answer) => {
                                return answer['status'] == "Delayed"
                            });
                        } else if (key == 'status' && activeFilters[key].value == 1) {
                            answersFiltered = answersFiltered.filter((answer) => {
                                return answer['status'] == "On Track"
                            });
                        } else if (key == 'status' && activeFilters[key].value == 0) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer
                          });
                        } else if (['documents', 'notes', 'auditor_notes'].includes(key) && activeFilters[key].value == 1) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer[key] == 0
                          });
                        } else if (['documents', 'notes', 'auditor_notes'].includes(key) && activeFilters[key].value == 2) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer[key] > 0
                          });
                        } else if (['archived'].includes(key) && activeFilters[key].value == 1) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer[key] === null
                          });
                        } else if (['archived'].includes(key) && activeFilters[key].value == 2) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer[key] === null || answer[key] === 1
                          });
                        } else if (['archived'].includes(key) && activeFilters[key].value == 3) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer[key] === 1
                          });
                        } else if (['notes'].includes(key) && activeFilters[key].value == 3) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer['complaints'] > 0;
                          });
                        }  else if (['notes'].includes(key) && activeFilters[key].value == 4) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer['outcomes_good'] > 0 || answer['outcomes_poor'] > 0;
                          });
                        } else if (['notes'].includes(key) && activeFilters[key].value == 5) {
                          answersFiltered = answersFiltered.filter((answer) => {
                            return answer['outcomes_change'] > 0;
                          });
                        } else if (key !== 'sortColumn' && key !== 'sortDir' && key !== 'scrollY' && activeFilters[key].value != 0 && this.parsedProps.filters[key]) {
                            answersFiltered = answersFiltered.filter((answer) => {
                                return answer[key] === activeFilters[key].value - 1 || answer[key] == this.parsedProps.filters[key]['data'][activeFilters[key].value];
                            });
                        }
                    }
                });

                if (!filters) {
                    this.setHistoryUrlParams();
                }

                return answersFiltered;
            },
            checkCorrectlyAnsweredStatus(){
                return this.selectedFilters['status'] && (this.selectedFilters['status'].value === 5 || this.selectedFilters['status'].value === 0);
            },
            sortSeverityGroupBy: function (column, index) {
                if(this.severityGroups[index]){
                    this.severityGroups[index].answers = this.sortBy(this.severityGroups[index].answers, column);
                }
            },
          sortBy: function (answers, column = null, toggleDir = true) {
            let answersSorted = answers;

            if (column && column !== this.sortColumn) {
              this.sortColumn = column;
              this.sortDir = 'asc';
            }

            let currentDir = this.sortDir;
            if (toggleDir) {
              currentDir = (this.sortDir === 'desc') ? 'asc' : 'desc';
            }

            if (currentDir === 'asc') {
              answersSorted = this.sort(answers, this.sortColumn, -1);
              this.currentSortActiveDirection = 'active fa-sort-desc';
            }
            if (currentDir === 'desc') {
              answersSorted = this.sort(answers, this.sortColumn, 1);
              this.currentSortActiveDirection = 'active fa-sort-asc';
            }

            if (toggleDir) {
              this.sortDir = currentDir;
            }

            this.setHistoryUrlParams();

            return answersSorted;
          },

          sort: function (answers, column, modifier) {
                return answers.sort((a, b) => {
                    if (a[column] == null) {
                        a[column] = '';
                    }
                    if (b[column] == null) {
                        b[column] = '';
                    }

                    let aVal = column == 'status' ? this.getStatusOrder(a[column]) : a[column];
                    let bVal = column == 'status' ? this.getStatusOrder(b[column]) : b[column];

                    if (aVal < bVal) return -1 * modifier;
                    if (aVal > bVal) return 1 * modifier;
                    return 0;
                });
            },
            severityTitle: function (severity) {
                if(this.parsedProps.severityLabels && this.parsedProps.severityLabels[severity]){
                    return this.parsedProps.severityLabels[severity];
                }

                switch(severity){
                    case 1:
                        return 'Medium Risk Rule Breach';
                    case 2:
                        return 'Low Risk Good Practice';
                    default:
                        return 'High Risk Significant Rule Breach';
                }
            },
            completedLinkTitle: function (severity, count) {
                if(count == 1)
                    var text = 'action';
                else
                    var text = 'actions';

                const label = this.parsedProps.severityLabels && this.parsedProps.severityLabels[severity] ? 
                    this.parsedProps.severityLabels[severity].toLowerCase() : null;

                switch(severity){
                    case 1:
                        return `View ${count} completed ${label || 'medium risk'} ${text}`;
                    case 2:
                        return `View ${count} completed ${label || 'low risk'} ${text}`;
                    default:
                        return `View ${count} completed ${label || 'high risk'} ${text}`;
                }
            },
            answersColor: function (answers) {
                return answers.map((item) => {
                    if (item.value < 3 && item.severity) {
                        item.color = 0;
                    }
                    if (item.value < 3 && item.severity === 0) {
                        item.color = 0;
                    }
                    if (item.value < 3 && item.severity === 1) {
                        item.color = 1;
                    }
                    if (item.value < 3 && item.severity === 2) {
                        item.color = 2;
                    }
                    if (item.value >= 3) {
                        item.color = 3;
                    }
                    return item;
                });
            },
            severityColor: function (severity) {
                switch(severity){
                    case 1:
                        return 'amber';
                    case 2:
                        return 'green';
                    default:
                        return 'red';
                }
            },
          printPage() {
            this.inProcess(true);
            let params = this.queryUrlParams;
            let account = this.parsedProps.account.id;

            let src = `/assessment/action-tracker-print/${account}${params}`;

            let iframe = document.createElement('iframe');
            iframe.setAttribute('src', src);
            iframe.setAttribute('height', '0');
            iframe.setAttribute('name', 'for_print');
            iframe.setAttribute('id', 'for_print');
            iframe.style.position = 'absolute';

            document.body.appendChild(iframe);

            iframe.onload = function () {
              window.frames['for_print'].focus();
              window.frames['for_print'].print();

              setTimeout(() => {
                document.body.removeChild(iframe);
              }, 100);
            };

            setTimeout(() => {
              this.inProcess(false);
            }, 1000);
          },
          inProcess(process) {
            const icon = document.getElementById('printActionTracker');
            if (process) {
              icon.classList.remove("fa-print");
              icon.classList.add("fa-spinner");
              icon.classList.add("fa-spin");
            } else {
              icon.classList.remove("fa-spin");
              icon.classList.remove("fa-spinner");
              icon.classList.add("fa-print");
            }
          },
          onGroupByChange() {
            if (this.groupBySeverity === false) {
              this.selectedFilters = {
                ...this.selectedFilters,
                status: { name: 'All', value: 0 }
              };

              const statusIndex = this.filtersData.findIndex(f => f.name === 'status');
              if (statusIndex !== -1) {
                this.filtersData = this.filtersData.map((f, i) =>
                    i === statusIndex ? { ...f, selected: 0 } : f
                );
              }

              this.sortColumn = 'question_auditor_index';
              this.sortDir = 'desc';
            }

            this.severityGroups = this.initialData('question_auditor_index', false);
          },

          async handleReportClick() {
            if (this.selectedReportFormat === 'pdf') {
              window.open(this.downloadconsumerdutyreportpdfurl, '_blank');
              return;
            }

            if (this.reportState.status === 'processing') return;

            if (this.reportState.status === 'idle') {
              this.reportState.status = 'processing';
              try {
                await axios.post('/export-doc-consumer-duty-report');
                this.pollReport();
              } catch (e) {
                this.reportState.status = 'error';
              }
            } else if (this.reportState.status === 'ready') {
              window.open(this.reportState.url, '_blank');
            }
          },

          async pollReport() {
            const interval = setInterval(async () => {
              try {
                const res = await axios.get('/download-consumer-duty-report');
                if (res.status === 200 && res.data.status === 'ready') {
                  clearInterval(interval);
                  this.reportState = {
                    status: 'ready',
                    url: res.data.url
                  };
                } else if (res.data.status === 'error') {
                  clearInterval(interval);
                  this.reportState.status = 'error';
                }
              } catch (e) {
                clearInterval(interval);
                this.reportState.status = 'error';
              }
            }, 2000);
          },

          isNaAnswer(answer) {
            const answerText = String(answer.answer || '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, '');

            return ['n/a', 'na'].includes(answerText);
          },

          isNaAnswerFilterSelected() {
            const answerFilter = this.selectedFilters['answer'];

            if (!answerFilter) {
              return false;
            }

            const answerFilterName = String(answerFilter.name || '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, '');

            return ['n/a', 'na'].includes(answerFilterName);
          },

          hideNaAnswersUnlessFiltered(answers) {
            // Networks with the actionTrackerShowNa feature keep N/A answers
            // in the normal view (required for audit reporting)
            if (this.shownaanswers) {
              return answers;
            }

            if (this.isNaAnswerFilterSelected()) {
              return answers;
            }

            return answers.filter(answer => !this.isNaAnswer(answer));
          },
        }
    }
</script>

<style scoped>
.btn {
  margin: 0;
}
.btn-report span {
  font-size: 12px;
  line-height: 20px;
}
.btn-report {
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  background-color: #EFC100;
  padding: 6px 10px;
}
.ai-generated-btn {
  background-color: #5b45d9;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  margin-top: 10px;
}

.ai-generated-btn i {
  margin: 4px;
  font-size: 10px;
}
</style>
